/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as NomineeRouteImport } from './routes/_nominee/route'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as NomineeNomineeDashboardImport } from './routes/_nominee/nominee-dashboard'
import { Route as AuthenticatedPaymentsImport } from './routes/_authenticated/payments'
import { Route as AuthenticatedDashboardImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedClaimsImport } from './routes/_authenticated/claims'
import { Route as AuthenticatedBeneficiariesImport } from './routes/_authenticated/beneficiaries'
import { Route as errors503Import } from './routes/(errors)/503'
import { Route as errors500Import } from './routes/(errors)/500'
import { Route as errors404Import } from './routes/(errors)/404'
import { Route as errors403Import } from './routes/(errors)/403'
import { Route as errors401Import } from './routes/(errors)/401'
import { Route as authSignUpImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2Import } from './routes/(auth)/sign-in-2'
import { Route as authSignInImport } from './routes/(auth)/sign-in'
import { Route as authOtpImport } from './routes/(auth)/otp'
import { Route as authOnboardingImport } from './routes/(auth)/onboarding'
import { Route as authNomineeRegisterImport } from './routes/(auth)/nominee-register'
import { Route as authForgotPasswordImport } from './routes/(auth)/forgot-password'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/_admin/route'
import { Route as AuthenticatedSettingsIndexImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedPaymentIndexImport } from './routes/_authenticated/payment/index'
import { Route as AuthenticatedHelpCenterIndexImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedSettingsNotificationsImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsDisplayImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedAdminProductsImport } from './routes/_authenticated/_admin/products'
import { Route as AuthenticatedAdminAdminPaymentsImport } from './routes/_authenticated/_admin/admin-payments'
import { Route as AuthenticatedAdminAdminClaimsImport } from './routes/_authenticated/_admin/admin-claims'
import { Route as AuthenticatedAdminAdminBeneficiariesImport } from './routes/_authenticated/_admin/admin-beneficiaries'
import { Route as AuthenticatedAdminAdminAccountsImport } from './routes/_authenticated/_admin/admin-accounts'
import { Route as authSignUpSsoCallbackImport } from './routes/(auth)/sign-up/sso-callback'
import { Route as authSignInSsoCallbackImport } from './routes/(auth)/sign-in/sso-callback'
import { Route as authOnboardingProtectionImport } from './routes/(auth)/onboarding.protection'
import { Route as authOnboardingIncomeImport } from './routes/(auth)/onboarding.income'
import { Route as authOnboardingEmploymentImport } from './routes/(auth)/onboarding.employment'
import { Route as authOnboardingCoverageImport } from './routes/(auth)/onboarding.coverage'
import { Route as authOnboardingConfirmationImport } from './routes/(auth)/onboarding.confirmation'
import { Route as authOnboardingCompleteImport } from './routes/(auth)/onboarding.complete'
import { Route as AuthenticatedSettingsOrganizationIndexImport } from './routes/_authenticated/settings/organization/index'

// Create/Update Routes

const NomineeRouteRoute = NomineeRouteImport.update({
  id: '/_nominee',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const NomineeNomineeDashboardRoute = NomineeNomineeDashboardImport.update({
  id: '/nominee-dashboard',
  path: '/nominee-dashboard',
  getParentRoute: () => NomineeRouteRoute,
} as any)

const AuthenticatedPaymentsRoute = AuthenticatedPaymentsImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedDashboardRoute = AuthenticatedDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedClaimsRoute = AuthenticatedClaimsImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedBeneficiariesRoute = AuthenticatedBeneficiariesImport.update(
  {
    id: '/beneficiaries',
    path: '/beneficiaries',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const errors503Route = errors503Import.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRoute,
} as any)

const errors500Route = errors500Import.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRoute,
} as any)

const errors404Route = errors404Import.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRoute,
} as any)

const errors403Route = errors403Import.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRoute,
} as any)

const errors401Route = errors401Import.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRoute,
} as any)

const authSignUpRoute = authSignUpImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const authSignIn2Route = authSignIn2Import.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRoute,
} as any)

const authSignInRoute = authSignInImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const authOtpRoute = authOtpImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRoute,
} as any)

const authOnboardingRoute = authOnboardingImport.update({
  id: '/(auth)/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRoute,
} as any)

const authNomineeRegisterRoute = authNomineeRegisterImport.update({
  id: '/(auth)/nominee-register',
  path: '/nominee-register',
  getParentRoute: () => rootRoute,
} as any)

const authForgotPasswordRoute = authForgotPasswordImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedSettingsRouteRoute = AuthenticatedSettingsRouteImport.update(
  {
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any,
)

const AuthenticatedPaymentIndexRoute = AuthenticatedPaymentIndexImport.update({
  id: '/payment/',
  path: '/payment/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

const AuthenticatedAdminProductsRoute = AuthenticatedAdminProductsImport.update(
  {
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any,
)

const AuthenticatedAdminAdminPaymentsRoute =
  AuthenticatedAdminAdminPaymentsImport.update({
    id: '/admin-payments',
    path: '/admin-payments',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)

const AuthenticatedAdminAdminClaimsRoute =
  AuthenticatedAdminAdminClaimsImport.update({
    id: '/admin-claims',
    path: '/admin-claims',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)

const AuthenticatedAdminAdminBeneficiariesRoute =
  AuthenticatedAdminAdminBeneficiariesImport.update({
    id: '/admin-beneficiaries',
    path: '/admin-beneficiaries',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)

const AuthenticatedAdminAdminAccountsRoute =
  AuthenticatedAdminAdminAccountsImport.update({
    id: '/admin-accounts',
    path: '/admin-accounts',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)

const authSignUpSsoCallbackRoute = authSignUpSsoCallbackImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => authSignUpRoute,
} as any)

const authSignInSsoCallbackRoute = authSignInSsoCallbackImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => authSignInRoute,
} as any)

const authOnboardingProtectionRoute = authOnboardingProtectionImport.update({
  id: '/protection',
  path: '/protection',
  getParentRoute: () => authOnboardingRoute,
} as any)

const authOnboardingIncomeRoute = authOnboardingIncomeImport.update({
  id: '/income',
  path: '/income',
  getParentRoute: () => authOnboardingRoute,
} as any)

const authOnboardingEmploymentRoute = authOnboardingEmploymentImport.update({
  id: '/employment',
  path: '/employment',
  getParentRoute: () => authOnboardingRoute,
} as any)

const authOnboardingCoverageRoute = authOnboardingCoverageImport.update({
  id: '/coverage',
  path: '/coverage',
  getParentRoute: () => authOnboardingRoute,
} as any)

const authOnboardingConfirmationRoute = authOnboardingConfirmationImport.update(
  {
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => authOnboardingRoute,
  } as any,
)

const authOnboardingCompleteRoute = authOnboardingCompleteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => authOnboardingRoute,
} as any)

const AuthenticatedSettingsOrganizationIndexRoute =
  AuthenticatedSettingsOrganizationIndexImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/_nominee': {
      id: '/_nominee'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof NomineeRouteImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_admin': {
      id: '/_authenticated/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/nominee-register': {
      id: '/(auth)/nominee-register'
      path: '/nominee-register'
      fullPath: '/nominee-register'
      preLoaderRoute: typeof authNomineeRegisterImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/onboarding': {
      id: '/(auth)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof authOnboardingImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2Import
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpImport
      parentRoute: typeof rootRoute
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500Import
      parentRoute: typeof rootRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503Import
      parentRoute: typeof rootRoute
    }
    '/_authenticated/beneficiaries': {
      id: '/_authenticated/beneficiaries'
      path: '/beneficiaries'
      fullPath: '/beneficiaries'
      preLoaderRoute: typeof AuthenticatedBeneficiariesImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/claims': {
      id: '/_authenticated/claims'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof AuthenticatedClaimsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/payments': {
      id: '/_authenticated/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthenticatedPaymentsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_nominee/nominee-dashboard': {
      id: '/_nominee/nominee-dashboard'
      path: '/nominee-dashboard'
      fullPath: '/nominee-dashboard'
      preLoaderRoute: typeof NomineeNomineeDashboardImport
      parentRoute: typeof NomineeRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/(auth)/onboarding/complete': {
      id: '/(auth)/onboarding/complete'
      path: '/complete'
      fullPath: '/onboarding/complete'
      preLoaderRoute: typeof authOnboardingCompleteImport
      parentRoute: typeof authOnboardingImport
    }
    '/(auth)/onboarding/confirmation': {
      id: '/(auth)/onboarding/confirmation'
      path: '/confirmation'
      fullPath: '/onboarding/confirmation'
      preLoaderRoute: typeof authOnboardingConfirmationImport
      parentRoute: typeof authOnboardingImport
    }
    '/(auth)/onboarding/coverage': {
      id: '/(auth)/onboarding/coverage'
      path: '/coverage'
      fullPath: '/onboarding/coverage'
      preLoaderRoute: typeof authOnboardingCoverageImport
      parentRoute: typeof authOnboardingImport
    }
    '/(auth)/onboarding/employment': {
      id: '/(auth)/onboarding/employment'
      path: '/employment'
      fullPath: '/onboarding/employment'
      preLoaderRoute: typeof authOnboardingEmploymentImport
      parentRoute: typeof authOnboardingImport
    }
    '/(auth)/onboarding/income': {
      id: '/(auth)/onboarding/income'
      path: '/income'
      fullPath: '/onboarding/income'
      preLoaderRoute: typeof authOnboardingIncomeImport
      parentRoute: typeof authOnboardingImport
    }
    '/(auth)/onboarding/protection': {
      id: '/(auth)/onboarding/protection'
      path: '/protection'
      fullPath: '/onboarding/protection'
      preLoaderRoute: typeof authOnboardingProtectionImport
      parentRoute: typeof authOnboardingImport
    }
    '/(auth)/sign-in/sso-callback': {
      id: '/(auth)/sign-in/sso-callback'
      path: '/sso-callback'
      fullPath: '/sign-in/sso-callback'
      preLoaderRoute: typeof authSignInSsoCallbackImport
      parentRoute: typeof authSignInImport
    }
    '/(auth)/sign-up/sso-callback': {
      id: '/(auth)/sign-up/sso-callback'
      path: '/sso-callback'
      fullPath: '/sign-up/sso-callback'
      preLoaderRoute: typeof authSignUpSsoCallbackImport
      parentRoute: typeof authSignUpImport
    }
    '/_authenticated/_admin/admin-accounts': {
      id: '/_authenticated/_admin/admin-accounts'
      path: '/admin-accounts'
      fullPath: '/admin-accounts'
      preLoaderRoute: typeof AuthenticatedAdminAdminAccountsImport
      parentRoute: typeof AuthenticatedAdminRouteImport
    }
    '/_authenticated/_admin/admin-beneficiaries': {
      id: '/_authenticated/_admin/admin-beneficiaries'
      path: '/admin-beneficiaries'
      fullPath: '/admin-beneficiaries'
      preLoaderRoute: typeof AuthenticatedAdminAdminBeneficiariesImport
      parentRoute: typeof AuthenticatedAdminRouteImport
    }
    '/_authenticated/_admin/admin-claims': {
      id: '/_authenticated/_admin/admin-claims'
      path: '/admin-claims'
      fullPath: '/admin-claims'
      preLoaderRoute: typeof AuthenticatedAdminAdminClaimsImport
      parentRoute: typeof AuthenticatedAdminRouteImport
    }
    '/_authenticated/_admin/admin-payments': {
      id: '/_authenticated/_admin/admin-payments'
      path: '/admin-payments'
      fullPath: '/admin-payments'
      preLoaderRoute: typeof AuthenticatedAdminAdminPaymentsImport
      parentRoute: typeof AuthenticatedAdminRouteImport
    }
    '/_authenticated/_admin/products': {
      id: '/_authenticated/_admin/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthenticatedAdminProductsImport
      parentRoute: typeof AuthenticatedAdminRouteImport
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/payment/': {
      id: '/_authenticated/payment/'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof AuthenticatedPaymentIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
    '/_authenticated/settings/organization/': {
      id: '/_authenticated/settings/organization/'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationIndexImport
      parentRoute: typeof AuthenticatedSettingsRouteImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminAdminAccountsRoute: typeof AuthenticatedAdminAdminAccountsRoute
  AuthenticatedAdminAdminBeneficiariesRoute: typeof AuthenticatedAdminAdminBeneficiariesRoute
  AuthenticatedAdminAdminClaimsRoute: typeof AuthenticatedAdminAdminClaimsRoute
  AuthenticatedAdminAdminPaymentsRoute: typeof AuthenticatedAdminAdminPaymentsRoute
  AuthenticatedAdminProductsRoute: typeof AuthenticatedAdminProductsRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminAdminAccountsRoute: AuthenticatedAdminAdminAccountsRoute,
    AuthenticatedAdminAdminBeneficiariesRoute:
      AuthenticatedAdminAdminBeneficiariesRoute,
    AuthenticatedAdminAdminClaimsRoute: AuthenticatedAdminAdminClaimsRoute,
    AuthenticatedAdminAdminPaymentsRoute: AuthenticatedAdminAdminPaymentsRoute,
    AuthenticatedAdminProductsRoute: AuthenticatedAdminProductsRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsOrganizationIndexRoute: typeof AuthenticatedSettingsOrganizationIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
    AuthenticatedSettingsOrganizationIndexRoute:
      AuthenticatedSettingsOrganizationIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedBeneficiariesRoute: typeof AuthenticatedBeneficiariesRoute
  AuthenticatedClaimsRoute: typeof AuthenticatedClaimsRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedPaymentsRoute: typeof AuthenticatedPaymentsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedPaymentIndexRoute: typeof AuthenticatedPaymentIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedBeneficiariesRoute: AuthenticatedBeneficiariesRoute,
  AuthenticatedClaimsRoute: AuthenticatedClaimsRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedPaymentsRoute: AuthenticatedPaymentsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedPaymentIndexRoute: AuthenticatedPaymentIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface NomineeRouteRouteChildren {
  NomineeNomineeDashboardRoute: typeof NomineeNomineeDashboardRoute
}

const NomineeRouteRouteChildren: NomineeRouteRouteChildren = {
  NomineeNomineeDashboardRoute: NomineeNomineeDashboardRoute,
}

const NomineeRouteRouteWithChildren = NomineeRouteRoute._addFileChildren(
  NomineeRouteRouteChildren,
)

interface authOnboardingRouteChildren {
  authOnboardingCompleteRoute: typeof authOnboardingCompleteRoute
  authOnboardingConfirmationRoute: typeof authOnboardingConfirmationRoute
  authOnboardingCoverageRoute: typeof authOnboardingCoverageRoute
  authOnboardingEmploymentRoute: typeof authOnboardingEmploymentRoute
  authOnboardingIncomeRoute: typeof authOnboardingIncomeRoute
  authOnboardingProtectionRoute: typeof authOnboardingProtectionRoute
}

const authOnboardingRouteChildren: authOnboardingRouteChildren = {
  authOnboardingCompleteRoute: authOnboardingCompleteRoute,
  authOnboardingConfirmationRoute: authOnboardingConfirmationRoute,
  authOnboardingCoverageRoute: authOnboardingCoverageRoute,
  authOnboardingEmploymentRoute: authOnboardingEmploymentRoute,
  authOnboardingIncomeRoute: authOnboardingIncomeRoute,
  authOnboardingProtectionRoute: authOnboardingProtectionRoute,
}

const authOnboardingRouteWithChildren = authOnboardingRoute._addFileChildren(
  authOnboardingRouteChildren,
)

interface authSignInRouteChildren {
  authSignInSsoCallbackRoute: typeof authSignInSsoCallbackRoute
}

const authSignInRouteChildren: authSignInRouteChildren = {
  authSignInSsoCallbackRoute: authSignInSsoCallbackRoute,
}

const authSignInRouteWithChildren = authSignInRoute._addFileChildren(
  authSignInRouteChildren,
)

interface authSignUpRouteChildren {
  authSignUpSsoCallbackRoute: typeof authSignUpSsoCallbackRoute
}

const authSignUpRouteChildren: authSignUpRouteChildren = {
  authSignUpSsoCallbackRoute: authSignUpSsoCallbackRoute,
}

const authSignUpRouteWithChildren = authSignUpRoute._addFileChildren(
  authSignUpRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedAdminRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/nominee-register': typeof authNomineeRegisterRoute
  '/onboarding': typeof authOnboardingRouteWithChildren
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRouteWithChildren
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRouteWithChildren
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/beneficiaries': typeof AuthenticatedBeneficiariesRoute
  '/claims': typeof AuthenticatedClaimsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/payments': typeof AuthenticatedPaymentsRoute
  '/nominee-dashboard': typeof NomineeNomineeDashboardRoute
  '/': typeof AuthenticatedIndexRoute
  '/onboarding/complete': typeof authOnboardingCompleteRoute
  '/onboarding/confirmation': typeof authOnboardingConfirmationRoute
  '/onboarding/coverage': typeof authOnboardingCoverageRoute
  '/onboarding/employment': typeof authOnboardingEmploymentRoute
  '/onboarding/income': typeof authOnboardingIncomeRoute
  '/onboarding/protection': typeof authOnboardingProtectionRoute
  '/sign-in/sso-callback': typeof authSignInSsoCallbackRoute
  '/sign-up/sso-callback': typeof authSignUpSsoCallbackRoute
  '/admin-accounts': typeof AuthenticatedAdminAdminAccountsRoute
  '/admin-beneficiaries': typeof AuthenticatedAdminAdminBeneficiariesRoute
  '/admin-claims': typeof AuthenticatedAdminAdminClaimsRoute
  '/admin-payments': typeof AuthenticatedAdminAdminPaymentsRoute
  '/products': typeof AuthenticatedAdminProductsRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/payment': typeof AuthenticatedPaymentIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationIndexRoute
}

export interface FileRoutesByTo {
  '': typeof AuthenticatedAdminRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/nominee-register': typeof authNomineeRegisterRoute
  '/onboarding': typeof authOnboardingRouteWithChildren
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRouteWithChildren
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRouteWithChildren
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/beneficiaries': typeof AuthenticatedBeneficiariesRoute
  '/claims': typeof AuthenticatedClaimsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/payments': typeof AuthenticatedPaymentsRoute
  '/nominee-dashboard': typeof NomineeNomineeDashboardRoute
  '/': typeof AuthenticatedIndexRoute
  '/onboarding/complete': typeof authOnboardingCompleteRoute
  '/onboarding/confirmation': typeof authOnboardingConfirmationRoute
  '/onboarding/coverage': typeof authOnboardingCoverageRoute
  '/onboarding/employment': typeof authOnboardingEmploymentRoute
  '/onboarding/income': typeof authOnboardingIncomeRoute
  '/onboarding/protection': typeof authOnboardingProtectionRoute
  '/sign-in/sso-callback': typeof authSignInSsoCallbackRoute
  '/sign-up/sso-callback': typeof authSignUpSsoCallbackRoute
  '/admin-accounts': typeof AuthenticatedAdminAdminAccountsRoute
  '/admin-beneficiaries': typeof AuthenticatedAdminAdminBeneficiariesRoute
  '/admin-claims': typeof AuthenticatedAdminAdminClaimsRoute
  '/admin-payments': typeof AuthenticatedAdminAdminPaymentsRoute
  '/products': typeof AuthenticatedAdminProductsRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/payment': typeof AuthenticatedPaymentIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_nominee': typeof NomineeRouteRouteWithChildren
  '/_authenticated/_admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/nominee-register': typeof authNomineeRegisterRoute
  '/(auth)/onboarding': typeof authOnboardingRouteWithChildren
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRouteWithChildren
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRouteWithChildren
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/beneficiaries': typeof AuthenticatedBeneficiariesRoute
  '/_authenticated/claims': typeof AuthenticatedClaimsRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/payments': typeof AuthenticatedPaymentsRoute
  '/_nominee/nominee-dashboard': typeof NomineeNomineeDashboardRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/(auth)/onboarding/complete': typeof authOnboardingCompleteRoute
  '/(auth)/onboarding/confirmation': typeof authOnboardingConfirmationRoute
  '/(auth)/onboarding/coverage': typeof authOnboardingCoverageRoute
  '/(auth)/onboarding/employment': typeof authOnboardingEmploymentRoute
  '/(auth)/onboarding/income': typeof authOnboardingIncomeRoute
  '/(auth)/onboarding/protection': typeof authOnboardingProtectionRoute
  '/(auth)/sign-in/sso-callback': typeof authSignInSsoCallbackRoute
  '/(auth)/sign-up/sso-callback': typeof authSignUpSsoCallbackRoute
  '/_authenticated/_admin/admin-accounts': typeof AuthenticatedAdminAdminAccountsRoute
  '/_authenticated/_admin/admin-beneficiaries': typeof AuthenticatedAdminAdminBeneficiariesRoute
  '/_authenticated/_admin/admin-claims': typeof AuthenticatedAdminAdminClaimsRoute
  '/_authenticated/_admin/admin-payments': typeof AuthenticatedAdminAdminPaymentsRoute
  '/_authenticated/_admin/products': typeof AuthenticatedAdminProductsRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/payment/': typeof AuthenticatedPaymentIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/settings/organization/': typeof AuthenticatedSettingsOrganizationIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/settings'
    | '/forgot-password'
    | '/nominee-register'
    | '/onboarding'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/beneficiaries'
    | '/claims'
    | '/dashboard'
    | '/payments'
    | '/nominee-dashboard'
    | '/'
    | '/onboarding/complete'
    | '/onboarding/confirmation'
    | '/onboarding/coverage'
    | '/onboarding/employment'
    | '/onboarding/income'
    | '/onboarding/protection'
    | '/sign-in/sso-callback'
    | '/sign-up/sso-callback'
    | '/admin-accounts'
    | '/admin-beneficiaries'
    | '/admin-claims'
    | '/admin-payments'
    | '/products'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/help-center'
    | '/payment'
    | '/settings/'
    | '/settings/organization'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/forgot-password'
    | '/nominee-register'
    | '/onboarding'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/beneficiaries'
    | '/claims'
    | '/dashboard'
    | '/payments'
    | '/nominee-dashboard'
    | '/'
    | '/onboarding/complete'
    | '/onboarding/confirmation'
    | '/onboarding/coverage'
    | '/onboarding/employment'
    | '/onboarding/income'
    | '/onboarding/protection'
    | '/sign-in/sso-callback'
    | '/sign-up/sso-callback'
    | '/admin-accounts'
    | '/admin-beneficiaries'
    | '/admin-claims'
    | '/admin-payments'
    | '/products'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/help-center'
    | '/payment'
    | '/settings'
    | '/settings/organization'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_nominee'
    | '/_authenticated/_admin'
    | '/_authenticated/settings'
    | '/(auth)/forgot-password'
    | '/(auth)/nominee-register'
    | '/(auth)/onboarding'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/beneficiaries'
    | '/_authenticated/claims'
    | '/_authenticated/dashboard'
    | '/_authenticated/payments'
    | '/_nominee/nominee-dashboard'
    | '/_authenticated/'
    | '/(auth)/onboarding/complete'
    | '/(auth)/onboarding/confirmation'
    | '/(auth)/onboarding/coverage'
    | '/(auth)/onboarding/employment'
    | '/(auth)/onboarding/income'
    | '/(auth)/onboarding/protection'
    | '/(auth)/sign-in/sso-callback'
    | '/(auth)/sign-up/sso-callback'
    | '/_authenticated/_admin/admin-accounts'
    | '/_authenticated/_admin/admin-beneficiaries'
    | '/_authenticated/_admin/admin-claims'
    | '/_authenticated/_admin/admin-payments'
    | '/_authenticated/_admin/products'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/help-center/'
    | '/_authenticated/payment/'
    | '/_authenticated/settings/'
    | '/_authenticated/settings/organization/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  NomineeRouteRoute: typeof NomineeRouteRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authNomineeRegisterRoute: typeof authNomineeRegisterRoute
  authOnboardingRoute: typeof authOnboardingRouteWithChildren
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRouteWithChildren
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRouteWithChildren
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  NomineeRouteRoute: NomineeRouteRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authNomineeRegisterRoute: authNomineeRegisterRoute,
  authOnboardingRoute: authOnboardingRouteWithChildren,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRouteWithChildren,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRouteWithChildren,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/_nominee",
        "/(auth)/forgot-password",
        "/(auth)/nominee-register",
        "/(auth)/onboarding",
        "/(auth)/otp",
        "/(auth)/sign-in",
        "/(auth)/sign-in-2",
        "/(auth)/sign-up",
        "/(errors)/401",
        "/(errors)/403",
        "/(errors)/404",
        "/(errors)/500",
        "/(errors)/503"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/_admin",
        "/_authenticated/settings",
        "/_authenticated/beneficiaries",
        "/_authenticated/claims",
        "/_authenticated/dashboard",
        "/_authenticated/payments",
        "/_authenticated/",
        "/_authenticated/help-center/",
        "/_authenticated/payment/"
      ]
    },
    "/_nominee": {
      "filePath": "_nominee/route.tsx",
      "children": [
        "/_nominee/nominee-dashboard"
      ]
    },
    "/_authenticated/_admin": {
      "filePath": "_authenticated/_admin/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_admin/admin-accounts",
        "/_authenticated/_admin/admin-beneficiaries",
        "/_authenticated/_admin/admin-claims",
        "/_authenticated/_admin/admin-payments",
        "/_authenticated/_admin/products"
      ]
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated/settings/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/settings/account",
        "/_authenticated/settings/appearance",
        "/_authenticated/settings/display",
        "/_authenticated/settings/notifications",
        "/_authenticated/settings/",
        "/_authenticated/settings/organization/"
      ]
    },
    "/(auth)/forgot-password": {
      "filePath": "(auth)/forgot-password.tsx"
    },
    "/(auth)/nominee-register": {
      "filePath": "(auth)/nominee-register.tsx"
    },
    "/(auth)/onboarding": {
      "filePath": "(auth)/onboarding.tsx",
      "children": [
        "/(auth)/onboarding/complete",
        "/(auth)/onboarding/confirmation",
        "/(auth)/onboarding/coverage",
        "/(auth)/onboarding/employment",
        "/(auth)/onboarding/income",
        "/(auth)/onboarding/protection"
      ]
    },
    "/(auth)/otp": {
      "filePath": "(auth)/otp.tsx"
    },
    "/(auth)/sign-in": {
      "filePath": "(auth)/sign-in.tsx",
      "children": [
        "/(auth)/sign-in/sso-callback"
      ]
    },
    "/(auth)/sign-in-2": {
      "filePath": "(auth)/sign-in-2.tsx"
    },
    "/(auth)/sign-up": {
      "filePath": "(auth)/sign-up.tsx",
      "children": [
        "/(auth)/sign-up/sso-callback"
      ]
    },
    "/(errors)/401": {
      "filePath": "(errors)/401.tsx"
    },
    "/(errors)/403": {
      "filePath": "(errors)/403.tsx"
    },
    "/(errors)/404": {
      "filePath": "(errors)/404.tsx"
    },
    "/(errors)/500": {
      "filePath": "(errors)/500.tsx"
    },
    "/(errors)/503": {
      "filePath": "(errors)/503.tsx"
    },
    "/_authenticated/beneficiaries": {
      "filePath": "_authenticated/beneficiaries.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/claims": {
      "filePath": "_authenticated/claims.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/dashboard": {
      "filePath": "_authenticated/dashboard.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/payments": {
      "filePath": "_authenticated/payments.tsx",
      "parent": "/_authenticated"
    },
    "/_nominee/nominee-dashboard": {
      "filePath": "_nominee/nominee-dashboard.tsx",
      "parent": "/_nominee"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/(auth)/onboarding/complete": {
      "filePath": "(auth)/onboarding.complete.tsx",
      "parent": "/(auth)/onboarding"
    },
    "/(auth)/onboarding/confirmation": {
      "filePath": "(auth)/onboarding.confirmation.tsx",
      "parent": "/(auth)/onboarding"
    },
    "/(auth)/onboarding/coverage": {
      "filePath": "(auth)/onboarding.coverage.tsx",
      "parent": "/(auth)/onboarding"
    },
    "/(auth)/onboarding/employment": {
      "filePath": "(auth)/onboarding.employment.tsx",
      "parent": "/(auth)/onboarding"
    },
    "/(auth)/onboarding/income": {
      "filePath": "(auth)/onboarding.income.tsx",
      "parent": "/(auth)/onboarding"
    },
    "/(auth)/onboarding/protection": {
      "filePath": "(auth)/onboarding.protection.tsx",
      "parent": "/(auth)/onboarding"
    },
    "/(auth)/sign-in/sso-callback": {
      "filePath": "(auth)/sign-in/sso-callback.tsx",
      "parent": "/(auth)/sign-in"
    },
    "/(auth)/sign-up/sso-callback": {
      "filePath": "(auth)/sign-up/sso-callback.tsx",
      "parent": "/(auth)/sign-up"
    },
    "/_authenticated/_admin/admin-accounts": {
      "filePath": "_authenticated/_admin/admin-accounts.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/admin-beneficiaries": {
      "filePath": "_authenticated/_admin/admin-beneficiaries.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/admin-claims": {
      "filePath": "_authenticated/_admin/admin-claims.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/admin-payments": {
      "filePath": "_authenticated/_admin/admin-payments.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/products": {
      "filePath": "_authenticated/_admin/products.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/settings/account": {
      "filePath": "_authenticated/settings/account.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/appearance": {
      "filePath": "_authenticated/settings/appearance.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/display": {
      "filePath": "_authenticated/settings/display.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/notifications": {
      "filePath": "_authenticated/settings/notifications.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/help-center/": {
      "filePath": "_authenticated/help-center/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/payment/": {
      "filePath": "_authenticated/payment/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/index.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/organization/": {
      "filePath": "_authenticated/settings/organization/index.tsx",
      "parent": "/_authenticated/settings"
    }
  }
}
ROUTE_MANIFEST_END */
